import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../../context/AuthContext';
import { NavLinkStyled, NavLinksContainer, StyledToolbar } from '../Header';
import { Badge, Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { isUserLoggedIn } from '../../../context/AuthHelper';
import PrivateHeader from './PrivateHeader';
// import logo from '../../../assets/images/logo/logo.png';
import logo from '../../../assets/images/logo/VDMK-Logo-RGB-Rot.jpg';
import { PAGES_URLS, PRIVATE_PAGES, PROFILE_PAGES, PUBLIC_PAGES } from '../../../lib/constants/routes';
import React, { useState } from 'react';
import { IS_PRIVATE_PLATFORM } from '../../../lib/constants/constant';
import { isTrue } from '../../../utils/helper';
import { get } from 'lodash';
import { KeyboardArrowDown } from '@mui/icons-material';

function DesktopHeader({ unreadMessageCount }: any) {
	const { logout, authenticatedData } = useAuthentication();
	const navigate = useNavigate();

	const [anchorEl, setAnchorEl] = useState(null);

	const handleOpenMenu = (e: any) => {
		setAnchorEl(e.currentTarget);
	};
	const handleCloseMenu = () => {
		setAnchorEl(null);
	};

	if (IS_PRIVATE_PLATFORM) {
		return (
			<>
				<StyledToolbar>
					<Box
						sx={{
							ml: 1,
							maxWidth: '300px',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							display: 'flex',
							alignItems: 'center',
							padding: '0.5rem 0',
						}}
					>
						<Box>
							<img src={logo} alt="logo-VdMK"
								style={{height: 36, objectFit: 'contain' }}
							/>
							</Box>
					</Box>
					<NavLinksContainer>
						{PRIVATE_PAGES.filter((ele: any) => isTrue(ele.display)).map((ele, i) => (
							<React.Fragment key={i}>
								{get(ele, 'showBadge') ? (
									<>
										<Badge
											badgeContent={unreadMessageCount}
											color="primary"
											sx={{
												'& .MuiBadge-badge': {
													transform: `scale(0.9) translate(0%, 50%)`,
												},
											}}
										>
											<NavLinkStyled key={i} to={ele.url}>
												{ele.name}
											</NavLinkStyled>
										</Badge>
									</>
								) : (
									<NavLinkStyled key={i} to={ele.url}>
										{ele.name}
									</NavLinkStyled>
								)}
							</React.Fragment>
						))}
						<Box sx={{ display: 'flex' }}>
							<Button
								variant="text"
								endIcon={<KeyboardArrowDown />}
								onClick={handleOpenMenu}
								disableRipple
								sx={{ color: 'navbar.primary.main', fontWeight: '400', fontSize: '1rem', '&:hover': { backgroundColor: 'unset' } }}
							>
								{get(authenticatedData, 'user.username')}
							</Button>
							<Menu
								id="menu-appbar"
								anchorEl={anchorEl}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'left',
								}}
								keepMounted
								transformOrigin={{
									vertical: 'top',
									horizontal: 'left',
								}}
								open={Boolean(anchorEl)}
								onClose={handleCloseMenu}
							>
								{PROFILE_PAGES.map((ele, i) => (
									<MenuItem
										key={i}
										onClick={() => {
											handleCloseMenu();
											navigate(get(ele, 'url', ''));
										}}
									>
										{ele.name}
									</MenuItem>
								))}
								<MenuItem onClick={logout}>Abmelden</MenuItem>
							</Menu>
						</Box>
					</NavLinksContainer>
				</StyledToolbar>
			</>
		);
	}

	return (
		<>
			<StyledToolbar>
				{/* Logo */}
				<Typography variant="h6" noWrap>
					<img src={logo} alt="logo" />
				</Typography>

				{/* Nav Links */}
				<NavLinksContainer>
					{PUBLIC_PAGES.filter((ele) => ele.display === 'true').map((ele, i) => (
						<NavLinkStyled key={i} to={ele.url}>
							{ele.name}
						</NavLinkStyled>
					))}
				</NavLinksContainer>

				{!isUserLoggedIn() && (
					<Button variant="contained" onClick={() => navigate(PAGES_URLS.Login)}>
						Login
					</Button>
				)}
			</StyledToolbar>
			{isUserLoggedIn() && <PrivateHeader {...{ logout, authenticatedData }} />}
		</>
	);
}

export default DesktopHeader;
